<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">
                {{ final.id === 0 ? 'Crear' : 'Editar' }} Registro Final
              </p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save">
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">

              <!-- Fecha del Producto -->
              <div class="col-md-6">
                <label class="form-control-label">Fecha del producto</label>
                <argon-input type="date" v-model="final.product_date" />
              </div>

              <!-- Cantidad Final -->
              <div class="col-md-6">
                <label class="form-control-label">Cantidad final</label>
                <argon-input type="number" v-model="final.final_quantity" />
              </div>

              <!-- Calidad del Producto -->
              <div class="col-md-6">
                <label class="form-control-label">Calidad del producto</label>
                <argon-input type="text" v-model="final.product_quality" />
              </div>

              <!-- Ubicación de Almacenamiento -->
              <div class="col-md-6">
                <label class="form-control-label">Ubicación de almacenamiento</label>
                <select name="" id="" class="form-select" v-model="final.storage_location">
                  <option value="" disabled>Seleccione una bodega</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import 'select2/dist/css/select2.min.css';
import 'select2';

export default {
  name: "MinesExtractionsFinal",
  data() {
    return {
      final: {
        id: 0,
        mines_extractions_id: '',
        product_date: '',
        final_quantity: 0,
        product_quality: '',
        storage_location: '',
        observation: 'Test',
      },
      form: {
        id: 0,
        mines_extractions_id: '',
        name: '',
        location: '',
        extraction_date: '',
        extracted_quantity: '',
        equipment_used: '',
        worker: '',
        quality: '',
        humidity: '',
        notes: ''
      },
      bodegas: [],
    };
  },
  components: {
    ArgonInput,
    ArgonButton,
  },
  methods: {
    async loadFinal(id) {
      try {
        const response = await this.$store.dispatch("minesExtractionsFinal/getData", id);
        this.final = { ...this.final, ...response.data };
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información.',
        });
      }
    },
    async save() {
      try {
        const response = await this.$store.dispatch("minesExtractionsFinal/save", this.final);
        if (response && response.status >= 200 && response.status < 300) {
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: `Final ${this.final.id === 0 ? 'creado' : 'actualizado'} correctamente`,
            confirmButtonText: 'Aceptar',
          }).then(() => {
            this.$router.push({
              name: 'Extraction Create',
              params: {
                id: this.final.mines_extractions_id,
                data: JSON.stringify(this.form)
              },
              query: { tab: 2 }
            });
          });
        } else {
          throw new Error(response?.data?.message || 'Ocurrió un error');
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar la información final',
        });
      }
    },
    async getUsers() {
      const response = await this.$store.dispatch("users/getAll");
      this.users = response;
    },
    async getDataExtraction() {
      const id = this.final.mines_extractions_id;
      if (!id) return;
      try {
        const response = await this.$store.dispatch("minesExtractions/getData", id);
        this.form = { ...this.form, ...response.data };
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
  },
  mounted() {
    const data = this.$route.params.data;
    if (data) {
      try {
        const params = JSON.parse(data);
        if (params.id > 0) {
          this.final = { ...this.final, ...params };
        } else {
          this.final.mines_extractions_id = params.mines_extractions_id;
        }
      } catch (error) {
        console.error("Error al parsear datos:", error);
      }
    }
    this.getDataExtraction();
    this.getBodegas();
    this.loadFinal(this.final.id);
    setNavPills();
    setTooltip();
  },
};
</script>
